<template>
    <!-- BRANDS-1
    ============================================= -->
    <div id="brands-1" class="pt-60 pb-60 brands-section division">
        <div class="container">


            <!-- BRANDS TITLE -->
            <div class="row justify-content-center">
                <div class="col-lg-8">
                    <div class="brands-title text-center">
                        <!-- add total user count -->
                        <p class="p-xl">Over {{ statistics.users }}+ customers have used CREDITFIXRR.COM.</p>
                    </div>
                </div>
            </div>


            <!-- Brands Carousel -->
            <div class="row">
                <div class="col text-center">
                    <div class="owl-carousel brands-carousel">


                        <!-- BRAND LOGO IMAGE -->
                        <div class="brand-logo">
                            <img class="img-fluid" src="/landing/images/experian.png" alt="brand-logo" />
                        </div>

                        <!-- BRAND LOGO IMAGE -->
                        <div class="brand-logo">
                            <img class="img-fluid" src="/landing/images/transunion.png" alt="brand-logo" />
                        </div>

                        <!-- BRAND LOGO IMAGE -->
                        <div class="brand-logo">
                            <img class="img-fluid" src="/landing/images/equifax.png" alt="brand-logo" />
                        </div>

                        <!-- BRAND LOGO IMAGE -->
                        <div class="brand-logo">
                            <img class="img-fluid" src="/landing/images/smartcredit.png" alt="brand-logo" />
                        </div>

                        <!-- BRAND LOGO IMAGE -->
                        <div class="brand-logo">
                            <img class="img-fluid" src="/landing/images/identityiq.png" alt="brand-logo">
                        </div>

                        <!-- BRAND LOGO IMAGE -->
                        <div class="brand-logo">
                            <img class="img-fluid" src="/landing/images/myscoreiq.png" alt="brand-logo" />
                        </div>

                        <!-- BRAND LOGO IMAGE -->
                        <div class="brand-logo">
                            <img class="img-fluid" src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/logos%2Fmyfreescorenow-logo.png" alt="brand-logo" />
                        </div>
                    </div>
                </div>
            </div>	<!-- End Brands Carousel -->


        </div>	    <!-- End container -->
    </div>	<!-- END BRANDS-1 -->
</template>
<script>
export default{
    props: {
        statistics: {
            type: [Array, Object]
        }
    },
    mounted(){
    },
    methods:{

    }
}
</script>
